import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-course-pattern',
  templateUrl: './course-pattern.component.html',
  styleUrls: ['./course-pattern.component.css']
})
export class CoursePatternComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
